
        
        function render() {
          var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":"63","height":"101","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M31.344 19.25c-5.273 0-9.375-4.102-9.375-9.375C21.97 4.797 26.266.5 31.344.5s9.375 4.297 9.375 9.375c0 5.273-4.297 9.375-9.375 9.375zm30.274 34.18c1.757 2.93.78 6.836-2.149 8.789-.976.586-2.148.781-3.125.781-2.148 0-4.297-.977-5.664-2.93l-6.445-10.156L52.829 75.5h-7.813v18.75c0 3.516-2.93 6.25-6.25 6.25-3.516 0-6.25-2.734-6.25-6.25V75.5h-3.125v18.75c0 3.516-2.734 6.25-6.055 6.25-3.515 0-6.25-2.734-6.25-6.25V75.5H9.274l8.594-25.586-6.25 10.156C9.664 63 5.954 63.977 3.024 62.22.094 60.267-.882 56.36.875 53.43l12.11-18.945c3.32-5.664 9.375-8.984 15.82-8.984h4.883c6.445 0 12.5 3.32 15.82 8.984l12.11 18.946z","fill":"#F84787"}})]);
        };
      

        module.exports = {
          
          render: render,
        };
      